import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { SalesOrderBCInformationDto } from "../models/orders/salesOrderBCInformation";
import { QuotesEmailLogs } from "../models/qoutes/quotesEmailLogs";
import { QuotesNotes } from "../models/qoutes/quotesNotes";
import { Contact } from "../models/shared/contact";

@Injectable({
  providedIn: "root",
})
export class PoEmailQuoteService {
  private quoteManagementBaseURL = environment.baseUrl + "/QuotesManagement";
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";

  constructor(private _http: HttpClient) {}

  getSalesOrderBCInformation(
    salesOrderId: string
  ): Observable<GenericResponseDto<SalesOrderBCInformationDto>> {
    return this._http.get<GenericResponseDto<SalesOrderBCInformationDto>>(
      `${this.quoteManagementBaseURL}/GetSalesOrderBCInformation?SaleOrderId=${salesOrderId}`
    );
  }

  createQuotesEmailLogs(
    poEmailLogs: QuotesEmailLogs
  ): Observable<GenericResponseDto<QuotesEmailLogs>> {
    return this._http.post<GenericResponseDto<QuotesEmailLogs>>(
      `${this.quoteManagementBaseURL}/CreateQuotesEmailLogs`,
      poEmailLogs
    );
  }

  ProposalSummaryDocument(
    quoteId: string,
    watermarkType = ""
  ): Observable<GenericResponseDto<string>> {
    return this._http.get<GenericResponseDto<string>>(
      this.quoteManagementBaseURL +
        `/ProposalSummaryDocument?QuotesId=${quoteId}&WatermarkType=${watermarkType}`
    );
  }

  AddQuoteNotes(
    payload: QuotesNotes
  ): Observable<GenericResponseDto<number | null>> {
    return this._http.post<GenericResponseDto<number | null>>(
      this.quoteManagementBaseURL + "/AddQuotesNotes",
      payload
    );
  }

  getAllContactsByAccountNumber(
    accountNumber: string,
    partyNumber: string
  ): Observable<GenericResponseDto<Contact[]>> {
    return this._http.get<GenericResponseDto<Contact[]>>(
      `${this.clientManagementBaseURL}/GetAllContactsByAccountNumber?AccountNumber=${accountNumber}&PartyNumber=${partyNumber}`
    );
  }

  updateQuotesStatus(
    quotesId: string,
    status: string
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.get<GenericResponseDto<boolean>>(
      this.quoteManagementBaseURL +
        `/UpdateQuotesStatus?QuotesId=${quotesId}&Status=${status}`
    );
  }
}
